// Per-browser-tab ephemeral session id.
// Stored in sessionStorage so it is unique per tab and automatically cleared
// when the tab/window is closed — aligning with the "temporary until exit"
// data model (no CRM data or reports are retained on the server after exit).
// NOTE: the session id is a random, non-sensitive, unguessable UUID used only
// to key ephemeral server data — it is NOT an auth token or PII.
import { logError } from "@/lib/logger";

const KEY = "salestap-session-id";

function generateId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getSessionId() {
  if (typeof window === "undefined") return "";
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = generateId();
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch (error) {
    // Storage unavailable (e.g., privacy mode) — fall back to an in-memory id.
    logError("Session storage unavailable, using in-memory session id:", error);
    if (!window.__salestapSessionId) window.__salestapSessionId = generateId();
    return window.__salestapSessionId;
  }
}
